module.exports = __webpack_public_path__ + "static/media/xero.754c48b8.png";